<div class="create-product-modal" *ngIf="isVisible" (click)="closeModal()">
  <div class="create-product-modal__content" (click)="$event.stopPropagation()">
    <h2 class="create-product-modal__title">Add new Product</h2>
    <form class="create-product-modal__form" [formGroup]="createProductForm" (ngSubmit)="onSubmit()">
      <div class="create-product-modal__inputs-container">
        <div class="create-product-modal__input-container">
          <input type="text" formControlName="name" class="create-product-modal__input" placeholder="Name" required />
        </div>

        <div class="create-product-modal__input-container">
          <input
            type="text"
            formControlName="cost"
            class="create-product-modal__input"
            placeholder="Cost in credit"
            required
          />
        </div>

        <div class="create-product-modal__input-container">
          <input
            type="text"
            formControlName="stripeLink"
            class="create-product-modal__input"
            placeholder="Stripe link"
            required
          />
        </div>
        <div class="create-product-modal__input-container">
          <input
            type="text"
            formControlName="stripePrice"
            class="create-product-modal__input"
            placeholder="Stripe price"
            required
          />
        </div>
      </div>

      <div class="create-product-modal__buttons">
        <app-button type="submit" variant="main" size="md" [isLoading]="isLoading" [disabled]="isFormInvalid">
          <span *ngIf="isLoading" class="app-spinner app-spinner--inline"></span>
          <span *ngIf="!isLoading">{{ isEditMode ? "EDIT PRODUCT" : "ADD PRODUCT" }}</span>
        </app-button>

        <app-button type="button" variant="secondary" size="md" (click)="closeModal($event)">
          <span>CANCEL</span>
        </app-button>
      </div>

      <div *ngIf="errorMessage" class="create-product-modal__error-text create-product__error-message">
        {{ errorMessage }}
      </div>
    </form>
  </div>
</div>
